import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import isNull from 'lodash-es/isNull';
import moment from 'moment';
import { CalendarCustomHeaderComponent } from '../../widgets/custom-calendar-header';
import { EditableComponent } from '../editable.types';

@Component({
  templateUrl: './datetime-editable.component.html',
  styleUrls: ['./datetime-editable.component.scss'],
})
export class DateTimeEditableComponent extends EditableComponent implements OnInit {
  @ViewChild('dtPicker') dtPicker: MatDatepicker<moment.Moment>;

  public value;
  public editing: boolean = false;
  private _originalValue;
  public emptyCellOverlay;
  public error: boolean = false;
  customHeader = CalendarCustomHeaderComponent;

  ngOnInit(): void {
    super.ngOnInit();
    this.value = this.getValue();
    this.emptyCellOverlay = this.showEmptyHolder && isNull(this.value);
    this._originalValue = this.value;
    if (this.fieldDef.meta && this.fieldDef.meta.readonly) {
      this.readonly = this.fieldDef.meta.readonly;
    }
    this.formatDate();

    if (this.editMode) {
      this.editing = this.editMode;
      setTimeout(() => this.dtPicker?.open(), 100);
    }
  }

  edit() {
    if (!this.editing && !this.isDisabled) {
      this.editing = true;
      setTimeout(() => this.dtPicker?.open(), 100);
    }
  }

  hideEdit() {
    this.editing = false;
    this.editMode = false;
  }

  formatDate(): void {
    if (this.value && this.isNestedField) {
      this.value = this.value.map((item) => {
        const temLabel = item?.label?.includes('T00:00:00') ? moment(item?.label?.split('T')[0]) : moment(item.label);
        return {
          ...item,
          label: temLabel && moment(item.label).isValid() ? temLabel.format('YYYY-MM-DD') : '',
        };
      });
    } else if (this.value) {
      // If the datetime value contains "00:00:00" then it is intended to be the beginning of the day in UTC time.
      const tempValue =
        typeof this.value === 'string' && this.value.includes('T00:00:00')
          ? moment(this.value.split('T')[0])
          : moment(this.value);
      this.value = tempValue.isValid() ? tempValue.format('YYYY-MM-DD') : null;
    }
  }

  onBlur($event?: Event) {
    this.processUpdate();
  }

  processUpdate() {
    this.hideEdit();
    this.save();
    this.onEndEditing.emit();
  }

  save() {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  updateModel() {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }

  onDateChange(type: string, event: MatDatepickerInputEvent<Date>): void {
    if (!this.readonly) {
      if (!event.value) {
        this.value = null;
        this.processUpdate();
        return;
      }

      const momentDate = moment(event.value).utc().add(7, 'hours');
      this.value = momentDate.format('YYYY-MM-DD HH:mm:ss');
      this.emptyCellOverlay = this.showEmptyHolder && isNull(this.value);
      this.processUpdate();
    }
  }
}
